import React, { useEffect } from "react";
import Pagination from "@material-ui/lab/Pagination";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AutoSaveWithDebounce from "../Autosave/AutoSaveWithDebounce";
import ObjectCardContainer from "../ObjectCard/ObjectCardContainer";
import ObjectsTable from "../ObjectsTable/ObjectsTable";
import { useHistory } from "react-router-dom";
import ContractTableRow from "../ContractTableRow/ContractTableRow";


const RenderObjectsPagination = ({ currentPage, countPages, pageChange }) => {
    return (<Pagination count={countPages} page={currentPage} onChange={pageChange} className="mb-2"/>);
}


const RenderSearch = ({ setNewCurrentPage, searchObjects, searchString, clearSearch }) => {

    const searchSchema = Yup.object().shape({
        search: Yup.string().required(),
    });

    const clearSearchField = (form) => {
        form.setFieldValue('search', '')
        clearSearch()
    }

    const onSubmit = (values) => {
        if (values.search) {
            document.activeElement.blur();
            if (searchString !== values.search) {
                setNewCurrentPage(1)
            }
            return searchObjects(values.search)
        }
    }


    return (
      <div className="search mb-2"> {/*Строка поиска для модераторов */}
          <Formik initialValues={{ search: searchString ? searchString : "" }}
                  enableReinitialize
                  validationSchema={searchSchema}
                  onSubmit={onSubmit}>
              {(props) => (
                <Form onSubmit={props.handleSubmit}>
                    <div className="d-flex">
                        <Field name="search">
                            {({ field, form }) => (
                              <FormControl fullWidth size="small" variant="outlined">
                                  <InputLabel htmlFor="search">Введите название или ID
                                      объекта</InputLabel>
                                  <OutlinedInput
                                    {...field}
                                    type="text"
                                    label="Введите название или ID объекта"
                                    autoComplete="off"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            {field.value !== '' &&
                                              <IconButton onClick={() => clearSearchField(form)}
                                                          edge="end">
                                                  <CloseIcon/>
                                              </IconButton>}

                                        </InputAdornment>
                                    }
                                    labelWidth={50}
                                  />
                              </FormControl>

                            )}
                        </Field>

                        <AutoSaveWithDebounce debounceMs={1500} loaderCircle={true}/>

                    </div>
                </Form>
              )}
          </Formik>
      </div>

    )
}


const SearchOjects = (props) => {
    const {
        objects, searchCurrentPage, searchCountPages, searchObjects, searchString,
        clearSearch, setNewCurrentPage, objectsPercent, verified
    } = props

    let history = useHistory()
    let path = history.location.pathname


    const tableType = () => {
        let arrPathname = history.location.pathname.split("/")
        if (arrPathname.includes("contracts")) {
            return "contracts"
        }
        if (arrPathname.includes("access-right")) {
            return "access-right"
        }
        return "objects"
    }


    useEffect(() => {
        if (searchCountPages > 1) {
            searchObjects(searchString, searchCurrentPage)
        }
    }, [searchCurrentPage])


    const pageChange = (e, value) => {
        setNewCurrentPage(value)
    }

    return (
      <>
          <RenderSearch setNewCurrentPage={setNewCurrentPage}
                        searchObjects={searchObjects}
                        searchString={searchString}
                        clearSearch={clearSearch}/>

          {searchCountPages > 1 && <RenderObjectsPagination currentPage={searchCurrentPage}
                                                            countPages={searchCountPages}
                                                            pageChange={pageChange}/>}

          {tableType() === "objects" && <ObjectsTable moderator={true} objects={objects}>
              {objects && Object.keys(path === "/lk/busy-calendar/" || path === "/lk/busy-calendar" ? objectsPercent : objects).map(item =>
                <ObjectCardContainer key={item} {...objects[item]}/>
              )}
          </ObjectsTable>}

          {tableType() === "contracts" && <div className="contract-table">
              {objects && Object.keys(objects).map((item) => {
                  return <ContractTableRow key={objects[item].id} contract={objects[item]} verified={verified}/>
              })}
          </div>}

          {tableType() === "access-right" &&


            <div className="row cards-object row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-3">
                {objects && Object.keys(objects).map(object => <ObjectCardContainer
                    key={object} {...objects[object]}>
                      <div className="access">
                          <div className="access-role">
                                <span className="access-role__title">
                                    Доступ к объектам:
                                </span>
                              <span className="access-role__item">
                                    Соловьев Алексей
                                </span>
                          </div>
                          <div className="access-role ">
                                <span className="access-role__title">
                                    Доступ к счетам:
                                </span>
                              <span className="access-role__item">
                                    Соловьев Алексей,
                                    Соловьев Алексей,
                                    Соловьев Алексей
                                </span>
                          </div>
                      </div>
                  </ObjectCardContainer>
                )}
            </div>}

      </>

    )
}


export default SearchOjects
